import Barba from 'barba.js';
import store from 'store';
import transitionDefault from 'barba/transitions/transitionDefault';
import transitionRight from 'barba/transitions/transitionRight';
import transitionLeft from 'barba/transitions/transitionLeft';

// ------------------------------------------------------------------------
// INITIALIZE BARBA.JS
// ------------------------------------------------------------------------
require('barba/boot');


// ------------------------------------------------------------------------
// INITIALIZE THE VIEWS
// ------------------------------------------------------------------------
require('barba/views');

// ------------------------------------------------------------------------
// UPDATE ACTIVE URL & TRACKING CODE
// ------------------------------------------------------------------------
Barba.Dispatcher.on('newPageReady', (currentStatus /* , oldStatus */ /* , container */) => {
    // Add active URL to store (so main navigation can react)
    store.commit('app/setActiveUrl', currentStatus.url);

    // Track Pageview with Matomo
    if (typeof window._paq !== 'undefined') {
        window._paq.push(['setCustomUrl', currentStatus.url]);
        window._paq.push(['trackPageView']);
    }

    // Track Pageview with GoogleAnalytics
    if (typeof window.gtag !== 'undefined' && window.ua_id) {
        const path = (window.location.href).replace(window.location.origin, '').toLowerCase();
        window.gtag('js', new Date());
        window.gtag('config', window.ua_id, {
            anonymize_ip: true,
            page_title: document.title,
            page_path: path,
        });
    }

    // Reset loading state when changing view
    store.commit('app/setLoading', false);

    // Update Switch Link in Navigation
    const link = currentStatus.url.split(window.location.origin)[1].substring(1); // get path of current page
    const navigation = document.querySelector('.header__switch');
    const navigationLinks = navigation.querySelectorAll('.header__switch-link');
    const navigationLinkIsActive = navigation.querySelector(`[href="/${link}"]`);
    Array.prototype.forEach.call(navigationLinks, navigationLink => navigationLink.classList.remove('is-active'));
    if (navigationLinkIsActive) navigationLinkIsActive.classList.add('is-active');

});

let lastClickEl;
Barba.Dispatcher.on('linkClicked', (el) => {
    lastClickEl = el;
});

Barba.Dispatcher.on('initStateChange', () => {
    store.commit('app/setLoading', true);
});


// ------------------------------------------------------------------------
// SET TRANSITION
//
// You can create multiple transitions and list them here. The first valid one
// will be chosen with other transitions as fallback.
// ------------------------------------------------------------------------
Barba.Pjax.getTransition = () => {
    if (transitionRight.isValid(lastClickEl)) {
        lastClickEl = null;
        return transitionRight;
    }
    if (transitionLeft.isValid(lastClickEl)) {
        lastClickEl = null;
        return transitionLeft;
    }

    return transitionDefault;
};



// WEBPACK FOOTER //
// ./resources/assets/js/barba/index.js